import { render, staticRenderFns } from "./HistoryCounter.vue?vue&type=template&id=1c5188bd&scoped=true"
import script from "./HistoryCounter.vue?vue&type=script&setup=true&lang=ts"
export * from "./HistoryCounter.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./HistoryCounter.vue?vue&type=style&index=0&id=1c5188bd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c5188bd",
  null
  
)

export default component.exports